import { useEffect, useState } from "react";
import {
	BrowserRouter,
	Routes as RouteWrapper,
	Route,
	Navigate,
} from "react-router-dom";
import { connect } from "react-redux";

import { CheckPermission } from "scripts/helpers";
import {
	updateCategories,
	updateConfigs,
	updateSettings,
} from "scripts/reducer";
import Routes from "scripts/routes";
import API from "scripts/api";

import Loading from "components/loading";

const Component = ({
	onUpdateCategories,
	onUpdateConfigs,
	onUpdateSettings,
	permissions = [],
}) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { loaded } = state;

	const componentDidMount = () => {
		Promise.all([API.category.list({ paginate: false }), API.settings()])
			.then(([{ data: categories }, { data: settings }]) => {
				const configs = API.getCookie(process.env.REACT_APP_COOKIE_CONFIGS);

				if (configs) {
					onUpdateConfigs(configs);
				} else {
					API.setCookie(process.env.REACT_APP_COOKIE_CONFIGS, {
						cities: [settings.defaultCity],
						province: settings.defaultProvince,
					});

					onUpdateConfigs({
						cities: [settings.defaultCity],
						province: settings.defaultProvince,
					});
				}

				onUpdateSettings(settings);
				onUpdateCategories(categories);

				setState((prevState) => ({ ...prevState, loaded: true }));
			})
			.catch(() => {});
	};

	useEffect(componentDidMount, []);

	return loaded ? (
		<BrowserRouter basename="/">
			<RouteWrapper>
				{Routes.map(({ component: Component, name, path, routes }) => (
					<Route
						key={name}
						path={path}
						element={<Component routes={routes} />}
					>
						{routes?.map(
							({
								authority,
								component: Component,
								name,
								path,
								redirect,
								routes,
							}) =>
								redirect ? (
									<Route
										key={name}
										path={path}
										element={
											<Navigate
												to={redirect}
												replace
											/>
										}
									/>
								) : routes ? (
									routes.map(
										({
											authority,
											component: Component,
											name: routeName,
											path,
										}) =>
											!authority || CheckPermission(permissions, authority) ? (
												<Route
													key={routeName}
													path={path}
													element={
														<Component
															routeName={routeName}
															parentName={name}
														/>
													}
												/>
											) : (
												<Route
													key={routeName}
													path={path}
													element={
														<Navigate
															to="/403"
															replace
														/>
													}
												/>
											)
									)
								) : !authority || CheckPermission(permissions, authority) ? (
									<Route
										key={name}
										path={path}
										element={
											<Component
												routeName={name}
												parentName={name}
											/>
										}
									/>
								) : (
									<Route
										key={name}
										path={path}
										element={
											<Navigate
												to="/403"
												replace
											/>
										}
									/>
								)
						)}
					</Route>
				))}
				<Route
					path="*"
					element={
						<Navigate
							to="/404"
							replace
						/>
					}
				/>
			</RouteWrapper>
		</BrowserRouter>
	) : (
		<Loading />
	);
};

export default connect(
	(state) => {
		return {
			permissions: state.user.permissions,
		};
	},
	(dispatch) => {
		return {
			onUpdateCategories: (data) => dispatch(updateCategories(data)),
			onUpdateConfigs: (data) => dispatch(updateConfigs(data)),
			onUpdateSettings: (data) => dispatch(updateSettings(data)),
		};
	}
)(Component);
